export default class TimeSpan {
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
	milliseconds: number;

	constructor(
		days: number,
		hours: number,
		minutes: number,
		seconds: number,
		milliseconds: number
	) {
		if (milliseconds < 0 || milliseconds > 999)
			throw new Error("Milliseconds must be between 0 and 999.");
		if (seconds < 0 || seconds > 59)
			throw new Error("Seconds must be between 0 and 59.");
		if (minutes < 0 || minutes > 59)
			throw new Error("Minutes must be between 0 and 59.");
		if (hours < 0 || hours > 23)
			throw new Error("Hours must be between 0 and 23.");
		if (days < 0) throw new Error("Days must be greater than or zero to 0.");

		this.milliseconds = milliseconds;
		this.seconds = seconds;
		this.minutes = minutes;
		this.hours = hours;
		this.days = days;
	}

	toString(): string {
		// eslint-disable-next-line prettier/prettier
		return `${(this.hours + (this.days * 24)).toString().padStart(2, "0")}:${this.minutes.toString().padStart(2, "0")}:${this.seconds.toString().padStart(2, "0")}.${this.milliseconds.toString().padStart(3, "0")}000`;
	}
}

export const timeSpanZero = new TimeSpan(0, 0, 0, 0, 0);

export const millisecondsPerSecond = 1000;
export const millisecondsPerMinute = 60 * millisecondsPerSecond;
export const millisecondsPerHour = 60 * millisecondsPerMinute;
export const millisecondsPerDay = 24 * millisecondsPerHour;

/* eslint-disable prettier/prettier */
export function timeSpanFromMilliseconds(milliseconds: number) {
	if (milliseconds < 0)
		throw new Error ("Negative timespans not supported");

	const d = Math.floor(milliseconds / millisecondsPerDay);
	const h = Math.floor((milliseconds - (d * millisecondsPerDay)) / millisecondsPerHour);
	const m = Math.floor((milliseconds - (d * millisecondsPerDay) - (h * millisecondsPerHour)) / millisecondsPerMinute);
	const s = Math.floor((milliseconds - (d * millisecondsPerDay) - (h * millisecondsPerHour) - (m * millisecondsPerMinute)) / millisecondsPerSecond);
	const ms = milliseconds - (d * millisecondsPerDay) - (h * millisecondsPerHour) - (m * millisecondsPerMinute) - (s * millisecondsPerSecond);
	return new TimeSpan(d, h, m, s, ms);
}
/* eslint-enable prettier/prettier */
